var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1999 3.08901C5.1999 1.76901 4.1199 0.689014 2.7999 0.689014C1.4799 0.689014 0.399902 1.76901 0.399902 3.08901C0.399902 4.40901 1.4799 5.48901 2.7999 5.48901C4.1199 5.48901 5.1999 4.40901 5.1999 3.08901ZM7.5999 3.08901C7.5999 4.40901 8.6799 5.48901 9.9999 5.48901C11.3199 5.48901 12.3999 4.40901 12.3999 3.08901C12.3999 1.76901 11.3199 0.689013 9.9999 0.689014C8.6799 0.689014 7.5999 1.76901 7.5999 3.08901ZM14.7999 3.08901C14.7999 4.40901 15.8799 5.48901 17.1999 5.48901C18.5199 5.48901 19.5999 4.40901 19.5999 3.08901C19.5999 1.76901 18.5199 0.689013 17.1999 0.689013C15.8799 0.689013 14.7999 1.76901 14.7999 3.08901Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.c08810ad8921ee8f0baff5360969b7a8.svg";
export { ForwardRef as ReactComponent };